module.exports = __webpack_public_path__ + "img/HotPokerDiceJokerPoker_DG.31484ae0.png";